import { Translate } from '@frontend/translation';
import { UserNotificationsErrorWrapper } from './UserNotificationsError.css';
import { ToastAlert } from '@frontend/ui-elements';
import { RiAlertLine } from '@remixicon/react';

export default function UserNotificationsError() {
  return (
    <UserNotificationsErrorWrapper>
      <ToastAlert
        severity="warning"
        title={
          <Translate id="customer-platform.header.user.notifications.error.title" />
        }
        message={
          <Translate id="customer-platform.header.user.notifications.error.description" />
        }
        icon={<RiAlertLine size={24} />}
      ></ToastAlert>
    </UserNotificationsErrorWrapper>
  );
}
